import { render, staticRenderFns } from "./SensorAlert.vue?vue&type=template&id=88670f7c&scoped=true&"
import script from "./SensorAlert.vue?vue&type=script&lang=js&"
export * from "./SensorAlert.vue?vue&type=script&lang=js&"
import style0 from "./SensorAlert.vue?vue&type=style&index=0&id=88670f7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88670f7c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VDataTable,VIcon,VPagination,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88670f7c')) {
      api.createRecord('88670f7c', component.options)
    } else {
      api.reload('88670f7c', component.options)
    }
    module.hot.accept("./SensorAlert.vue?vue&type=template&id=88670f7c&scoped=true&", function () {
      api.rerender('88670f7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Sensors/SensorAlert.vue"
export default component.exports